import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProductCard } from "./ProductCard";

export const RelatedProducts = ({ product }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/products").then(({ data }) => {
      const others = data.filter((p) => p.id !== product.id);
      const score = (p) => (p.audience === product.audience ? 2 : 0) + (p.category === product.category ? 1 : 0);
      setItems(others.sort((a, b) => score(b) - score(a)).slice(0, 4));
    }).catch(() => {});
  }, [product.id, product.audience, product.category]);
  if (!items.length) return null;
  return (
    <section data-testid="related-products" className="mt-16">
      <h2 className="font-heading font-extrabold uppercase text-2xl lg:text-3xl text-white mb-6">You May Also Like</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
        {items.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
};
